import React, { useEffect, useState, useRef } from "react";
import ApiService from "../ApiService";
import {
  format_yyyy_mm_dd_to_DATETIME_MED,
  formatUSMobileNum,
  getAgeInYrsMonthsDisplay,
  getIsoToMediumFormatDatetime,
  getRegion
} from "../util/common.js";
import { Button, Container, Form, FormControl, InputGroup, Modal, Row, Col, Spinner, Overlay, Tooltip, OverlayTrigger } from "react-bootstrap";
import removeClass from "../util/RemoveCSS";
import MaterialTable from "material-table";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  AssignmentTurnedIn,
  Note,
  NoteAdd,
  NotInterested,
  PersonAdd,
  PostAdd,
  Send,
  AddBox,
  NotListedLocationOutlined,
  CachedRounded,
  Visibility,
  Healing
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import PatientProfileModal from "./PatientProfileModal";
import CreateTestResultModal from "./CreateTest/CreateTestResultModal";
import M19Input from "./M19Input/M19Input";
import { isM19Kit } from "../util/lab-request-util";
import { hideRelevantInfo, validClinicianLicenseStates } from "../util/licence-util";
import PageTitle from "./Common/PageTitle/PageTitle";
import { parseAxiosError } from "../util/parserHelper";
import ReactDOM from "react-dom";
import userImage from "../assets/user.png";
import { BsX, BsTelephoneFill, BsGeoAltFill } from "react-icons/bs";
import Image from "react-bootstrap/Image";
import { clinicianIdFromRefreshAuth } from "../util/authUtil";
import ReassignModal from "../components/Common/popUpModals/ReassignModal";
import { useHistory } from "react-router-dom";
import { FcInfo } from "react-icons/fc";
import ERXModal from "./Modal/eRx/ERXModal";
import { set } from "lodash";
import ErxService from "../service/erxService";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  },
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2)
    }
  }
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LabRequest = () => {
  const classes = useStyles();

  const [labRequests, setLabRequests] = useState([]);
  const [myStatesLabRequests, setMyStatesLabRequests] = useState([]);
  const [allStatesShow, setAllStatesShow] = useState(true);
  const [clinicianId, setClinicianId] = useState(null);
  const [licenseStates, setLicenseStates] = useState({});
  const [validStates, setValidStates] = useState([]);
  const [inValidStates, setInValidStates] = useState([]);
  const [show, setShow] = useState(null);
  const [showAddressDetails, setShowAddressDetails] = useState(null);
  const [noteKitId, setNoteKitId] = useState(null);
  const [internalNoteText, setInternalNoteText] = useState(null);
  const [externalNoteText, setExternalNoteText] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [loading, setLoading] = useState(true);
  const [messageModalShow, setMessageModalShow] = useState(false);
  const [messageKitId, setMessageKitId] = useState("");

  const [selectedPatient, setSelectedPatient] = useState({ address: {} });
  const [showCreateTestFormModal, setShowCreateFormModal] = useState(false);
  const [selectedKitId, setSelectedKitId] = useState(null);

  const [showM19Modal, setShowM19Modal] = useState(false);
  const [selectedTubeId, setSelectedTubeId] = useState(null);
  const [isSelectedKitReportReady, setSelectedKitReadyStatus] = useState(false);

  const [reassignModal, setReassignModal] = useState(false);
  const [activeKitId, setActiveKitId] = useState("");
  const [showErxModal, setShowErxModal] = useState(false);
  const [eRxid, setERxId] = useState("");

  const navigate = useHistory();

  const showAllStateMessages = () => {
    handleSnackOpen("Showing all Lab Requests", "success");
    setAllStatesShow(true);
  };

  const showMyStateMessages = () => {
    handleSnackOpen("Showing lab requests for your state", "info");
    setAllStatesShow(false);
  };

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  removeClass();

  const navigateToKitDetailPage = rowData => {
    navigate.push({
      pathname: "KitDetails",
      search: "?kitId=" + rowData.kitId,
      state: { kitDetails: rowData }
    });
  };

  const refreshRequestsFromRemote = async () => {
    setLoading(true);
    try {
      const res = await ApiService.getAssignedLabRequestsAll();
      const getRequests = hideRelevantInfo(res?.data, licenseStates?.inValidStates ?? []);
      //` 1: Set All Request
      setLabRequests(getRequests);
      //` 2: Set My State Request
      const validStates = await validClinicianLicenseStates().then(res => res);
      const myRequests = getRequests.filter(request => validStates.includes(request?.user?.address?.region));
      setMyStatesLabRequests(myRequests);
    } catch (err) {
      handleSnackOpen(`Lab requests refresh failed. Reason: ${parseAxiosError(err)?.reason}`, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    clinicianIdFromRefreshAuth()
      .then(id => setClinicianId(id))
      .catch(err => handleSnackOpen(`Failed getting clinicianId. Cause: ${parseAxiosError(err)?.reason}`, "error"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    if (clinicianId) {
      ApiService.getValidAndInvalidLicenseStates()
        .then(res => {
          const { validStates = [], inValidStates = [] } = res.data;
          setValidStates(validStates);
          setInValidStates(inValidStates);
          setLicenseStates({ validStates, inValidStates });
        })
        .catch(err => handleSnackOpen(`Failed getting license states. Cause: ${parseAxiosError(err)}`))
        .finally(() => setLoading(false));
    }
  }, [clinicianId]);

  useEffect(() => {
    setLoading(true);
    refreshRequestsFromRemote();
  }, [licenseStates]);

  function handleCreateTestResultClose(status) {
    if (status) {
      refreshRequestsFromRemote().then(r => r);
    }
    setShowCreateFormModal(false);
  }

  function handleM19InputClose(status) {
    if (status) {
      refreshRequestsFromRemote().then(r => r);
    }
    setShowM19Modal(false);
    setSelectedTubeId(null);
    setSelectedKitId(null);
    setSelectedKitReadyStatus(false);
  }
  async function assignToMe(kitId) {
    setBackdropOpen(true);
    await ApiService.putAssignLabRequest({ kitId: kitId })
      .then(resp => {
        refreshRequestsFromRemote().then(r => r);
        setBackdropOpen(false);
        handleSnackOpen("Assigned to You!", "success");
      })
      .catch(error => {
        const msg = error?.response?.data?.message ?? error?.message;
        setBackdropOpen(false);
        handleSnackOpen(msg, "error");
      });
  }

  const onReassign = () => {
    refreshRequestsFromRemote().then(r => r);
    setBackdropOpen(false);
    handleSnackOpen("Assigned to You!", "success");
  };

  function showM19FormModal(rowData) {
    setSelectedKitId(rowData.kitId);
    setSelectedTubeId(rowData.tubeId);
    setShowM19Modal(true);
    setSelectedKitReadyStatus(rowData.status === "REPORT_READY");
  }

  function approve(kitId) {
    setBackdropOpen(true);

    async function putApproveLabRequest() {
      try {
        // eslint-disable-next-line no-unused-vars
        const putApproveLabRequest = await ApiService.putApproveLabRequest({ kitId: kitId });
        setBackdropOpen(false);
        handleSnackOpen("Approved!", "success");
        refreshRequestsFromRemote().then(r => r);
      } catch (err) {
        const msg = err?.response?.data?.message ?? err?.message;
        console.error(err);
        setBackdropOpen(false);
        handleSnackOpen(msg, "error");
      }
    }

    putApproveLabRequest();
  }

  function rejectNotes(internalNotes, externalNotes) {
    setBackdropOpen(true);

    async function putRejectLabRequest() {
      try {
        // eslint-disable-next-line no-unused-vars
        const putRejectLabRequest = await ApiService.putRejectLabRequest({
          kitId: noteKitId,
          externalNote: externalNotes,
          internalNote: internalNotes
        });
        setBackdropOpen(false);
        handleSnackOpen("Reject Note Added", "success");
      } catch (err) {
        const msg = err?.response?.data?.message ?? err?.message;
        console.error(err);
        setBackdropOpen(false);
        handleSnackOpen(msg, "error");
      }
    }

    putRejectLabRequest();
  }

  function showCreateTestResultModal(kitId) {
    setShowCreateFormModal(true);
    setSelectedKitId(kitId);
  }

  function createFakeTestResults(kitId, email) {
    setBackdropOpen(true);

    async function postTestResult() {
      try {
        // eslint-disable-next-line no-unused-vars
        const postTestResult = await ApiService.postTestResult({ kitId: kitId, patientEmail: email })
          .then(r => r)
          .then(error => {
            const msg = error?.response?.data?.message ?? error?.message;
            setBackdropOpen(false);
            handleSnackOpen(msg, "error");
          });

        async function getAssignedLabResultsAll() {
          try {
            const getAssignedLabResultsAll = await ApiService.getAssignedLabResultsAll();
            setLabRequests(getAssignedLabResultsAll.data);
          } catch (ex) {
            console.error(ex);
          }
        }

        getAssignedLabResultsAll();
        setBackdropOpen(false);
        handleSnackOpen("Fake Test Result Created!", "success");
      } catch (err) {
        console.error(err);
        setBackdropOpen(false);
        handleSnackOpen(err.message, "error");
      }
    }

    postTestResult();
  }

  const handleClose = () => {
    setShow(false);
  };

  const handleReassignKitClose = () => {
    setReassignModal(false);
    setReassignModal(false);
    setActiveKitId("");
  };

  const handleShow = (kitId, internalNote, externalNote, status) => {
    setNoteKitId(kitId);
    setInternalNoteText(internalNote);
    setExternalNoteText(externalNote);
    "REJECTED_BY_CLINICIAN" === status ? setIsReadOnly(true) : setIsReadOnly(false);
    setShow(true);
  };

  const handleAddressessClose = () => {
    setShowAddressDetails(false);
  };

  const handleAddresseeShow = patient => {
    setSelectedPatient(patient);
    setShowAddressDetails(true);
  };

  function processNotes(event) {
    handleClose();
    event.preventDefault();
    const externalNotesNumels = document.getElementsByName("externalNotesText").length;
    const externalNotes = document.getElementsByName("externalNotesText")[externalNotesNumels - 1].value;
    const internalNotesNumels = document.getElementsByName("internalNotesText").length;
    const internalNotes = document.getElementsByName("internalNotesText")[internalNotesNumels - 1].value;
    rejectNotes(internalNotes, externalNotes);
  }

  const sendMessage = message => {
    handleSnackOpen("Sending Message...", "info");

    async function postPatientMessage() {
      try {
        // eslint-disable-next-line no-unused-vars
        const postPatientMessage = await ApiService.postPatientMessage({
          kitId: messageKitId,
          message: message
        });
        setLoading(false);
        handleSnackOpen("Message Sent!", "success");
      } catch (err) {
        const msg = err?.response?.data?.message ?? err?.message;
        console.error(err.message);
        handleSnackOpen(msg, "error");
      }
    }

    postPatientMessage();
  };

  const handleMessageModalset = (event, rowData) => {
    setMessageKitId(rowData.kitId);
    setMessageModalShow(true);
  };

  const hideErxModal = (orderCreated = false) => {
    setShowErxModal(false);
    if (orderCreated) {
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Prescription Sent!");
    }
  };
  const handleSendPrescription = async (event, rowData) => {
    try {
      const userDetailRes = await ApiService.getPatientDetailByEmail(rowData?.user?.email);
      const userDetail = userDetailRes?.data;
      const photonHealthErxPatientId = userDetailRes?.data?.photonHealthErxPatientId;

      if (!userDetail) {
        setSnackOpen(true);
        setSnackSeverity("error");
        setSnackText("Patient account not found");
        return;
      }

      if (photonHealthErxPatientId) {
        setShowErxModal(true);
        setERxId(photonHealthErxPatientId);
      } else {
        const sexAtBirth = ErxService.determineSexAtBirth(userDetail?.genderAtBirth ?? userDetail?.gender);
        const eRxIdRes = await ApiService.createPatientOnPhoton({
          patientId: userDetail?.subUUID,
          firstName: userDetail?.givenName,
          lastName: userDetail?.familyName,
          dob:  userDetail?.birthDate,
          sex: sexAtBirth,
          phone: userDetail?.phoneNumber,
          email: userDetail?.email,
          gender:userDetail?.gender,
          address: {
            name: {
              first: userDetail?.givenName,
              last: userDetail?.familyName
            },
            street1: userDetail?.address?.street_address,
            street2: userDetail?.address?.street_address2,
            postalCode: userDetail?.address?.postal_code,
            country: "USA",
            state: userDetail?.address?.region,
            city: userDetail?.address?.locality
          }
        });
        if (eRxIdRes?.data?.erxPhotonId?.id) {
          const res = await ApiService.updatePhotonERxPatientId(userDetail?.subUUID, eRxIdRes?.data?.erxPhotonId?.id);
          if (res) {
            setShowErxModal(true);
            setERxId(eRxIdRes?.data?.erxPhotonId?.id);
          }
        }
      }
    } catch (err) {
      console.log("err", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  function viewKitDetails(kitId) {
    navigate("/about");
  }

  if (!loading) {
    return (
      <Container fluid={"xxl"} style={{ paddingInline: 40 }}>
        <PageTitle titleName={"Lab Request"} />
        <Row className="results-requests-table">
          <div
            style={{
              width: 200,
              height: 45,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              background: "white",
              paddingInline: 12,
              borderRadius: 8,
              marginBottom: 12
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  backgroundColor: allStatesShow ? "rgba(151, 71, 255, 0.40)" : "white",
                  borderRadius: 5,
                  display: "grid",
                  placeItems: "center",
                  cursor: "pointer",
                  fontWeight: allStatesShow ? "800" : "400"
                }}
                onClick={showAllStateMessages}
              >
                All States
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  backgroundColor: !allStatesShow ? "rgba(151, 71, 255, 0.40)" : "white",
                  borderRadius: 5,
                  display: "grid",
                  placeItems: "center",
                  cursor: "pointer",
                  fontWeight: !allStatesShow ? "800" : "400"
                }}
                onClick={showMyStateMessages}
              >
                My States
              </div>
            </div>
          </div>
          <MaterialTable
            columns={[
              {
                title: "Patient Name",
                field: "user.name",
                render: rowData => <ShowProfile event={rowData} />,
                cellStyle: {
                  width: 150,
                  minWidth: 150,
                  cursor: "pointer",                  
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Preferred Name",
                field: "user.preferredName",
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Patient Email",
                field: "user.email",
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Kit ID",
                field: "kitId",
                cellStyle: {
                  width: 50,
                  minWidth: 50
                },
                headerStyle: {
                  width: 50,
                  minWidth: 50
                }
              },
              {
                title: "Status",
                field: "status",
                render: rowData => {
                  if (rowData.status === "APPROVED" && (rowData.autoApproved === "true" || rowData.autoApproved === true)) {
                    return (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            <div className="tooltipCard">per standing order</div>
                          </Tooltip>
                        }
                      >
                        <span>
                          <FcInfo title="Auto-approved" />
                          {"  "}
                          <span>AUTO APPROVED </span>
                        </span>
                      </OverlayTrigger>
                    );
                  }
                  return <span>APPROVED</span>;
                }
              },
              {
                title: "Clinician",
                field: "clinician.firstName",
                render: rowData => {
                  if (rowData.clinician !== null) {
                    return (
                      <span>
                        {rowData.clinician.firstName} {rowData.clinician.lastName}
                      </span>
                    );
                  } else {
                    return <span>needs clinician</span>;
                  }
                },
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              {
                title: "Date of Registration",
                field: "createDateTime",
                render: rowData => getIsoToMediumFormatDatetime(rowData.createDateTime),
                cellStyle: {
                  width: 150,
                  minWidth: 150
                },
                headerStyle: {
                  width: 150,
                  minWidth: 150
                }
              },
              { title: "Patient Sex at Birth", field: "user.genderAtBirth" },
              {
                title: "Patient DOB",
                field: "user.dob",
                render: rowData => (
                  <>
                    <div>{format_yyyy_mm_dd_to_DATETIME_MED(rowData.user?.dob)}</div>
                    <div>{getAgeInYrsMonthsDisplay(rowData.user?.dob)}</div>
                  </>
                ),
                cellStyle: {
                  width: 200,
                  minWidth: 200
                },
                headerStyle: {
                  width: 200,
                  minWidth: 200
                }
              },
              {
                title: "Phone Number",
                field: "phoneNumber",
                render: rowData => formatUSMobileNum(rowData.user?.phoneNumber),
                cellStyle: {
                  width: 170,
                  minWidth: 170
                },
                headerStyle: {
                  width: 170,
                  minWidth: 170
                },
                filtering: false
              },
              { title: "Allergies", field: "user.allergies", filtering: false },
              { title: "Current Medications", field: "medications", filtering: false },
              { title: "Current Symptoms", field: "symptoms", filtering: false },
              { title: "Patient State", field: "user.address.region" },
              { title: "Product Name", field: "productName" }
            ]}
            actions={[
              rowData => ({
                icon: () => <Visibility style={{ color: "orange" }} id={"assign-" + rowData.kitId} />,
                tooltip: "View Test kit",
                onClick: () => navigateToKitDetailPage(rowData)
              }),
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.status !== "REPORT_READY" && rowData.status !== "REJECTED_BY_CLINICIAN" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician === null) {
                      return {
                        icon: () => <PersonAdd id={"assign-" + rowData.kitId} />,
                        tooltip: "Assign To Me",
                        onClick: () => assignToMe(rowData.kitId)
                      };
                    } else {
                      if (rowData.status === "REGISTERED") {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <AssignmentTurnedIn id={"approve-" + rowData.kitId} name={"approve-" + rowData.kitId} />
                            </div>
                          ),
                          tooltip: "Approve",
                          onClick: () => approve(rowData.kitId)
                        };
                      } else if (process.env.REACT_APP_ENV === "sandbox") {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <NoteAdd id={"test-" + rowData.kitId} name={"test-" + rowData.kitId} />
                            </div>
                          ),
                          tooltip: "Create Fake Test Results",
                          onClick: () => createFakeTestResults(rowData.kitId, rowData.user?.email)
                        };
                      } else {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <NotInterested />
                            </div>
                          ),
                          tooltip: "No action needed",
                          disabled: true
                        };
                      }
                    }
                  } else if (rowData.status === "REJECTED_BY_CLINICIAN") {
                    return {
                      icon: () => <Note id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId} />,
                      tooltip: "View Reject Notes for Patient",
                      onClick: () => handleShow(rowData.kitId, rowData.internalNote, rowData.externalNote, rowData.status)
                    };
                  } else {
                    return {
                      icon: () => (
                        <div id={"action-" + rowData.kitId}>
                          <NotInterested />
                        </div>
                      ),
                      tooltip: "No action needed",
                      disabled: true
                    };
                  }
                } else {
                  if (rowData.status !== "REPORT_READY" && rowData.status !== "REJECTED_BY_CLINICIAN" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician === null) {
                      return {
                        icon: () => <PersonAdd className="gray-button" id={"assign-" + rowData.kitId} />,
                        tooltip: "Assigned to another clinician OR license ineligible",
                        disabled: true
                      };
                    } else {
                      if (rowData.status === "REGISTERED") {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <AssignmentTurnedIn className="gray-button" id={"approve-" + rowData.kitId} name={"approve-" + rowData.kitId} />
                            </div>
                          ),
                          tooltip: "Assigned to another clinician OR license ineligible",
                          disabled: true
                        };
                      } else if (process.env.REACT_APP_ENV === "sandbox") {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <NoteAdd className="gray-button" id={"test-" + rowData.kitId} name={"test-" + rowData.kitId} />
                            </div>
                          ),
                          tooltip: "Assigned to another clinician OR license ineligible",
                          disabled: true
                        };
                      } else {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <NotInterested className="gray-button" />
                            </div>
                          ),
                          tooltip: "Assigned to another clinician OR license ineligible",
                          disabled: true
                        };
                      }
                    }
                  } else if (rowData.status === "REJECTED_BY_CLINICIAN") {
                    return {
                      icon: () => <NoteAdd className="gray-button" id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId} />,
                      tooltip: "Assigned to another clinician OR license ineligible",
                      disabled: true,
                      onClick: () => handleShow(rowData.kitId, rowData.internalNote, rowData.externalNote, rowData.status)
                    };
                  } else {
                    return {
                      icon: () => (
                        <div id={"action-" + rowData.kitId}>
                          <NotInterested className="gray-button" />
                        </div>
                      ),
                      tooltip: "Assigned to another clinician OR license ineligible",
                      disabled: true
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (["REPORT_READY", "REJECTED_BY_CLINICIAN", "COMPLETE"].indexOf(rowData.status) === -1 && rowData.clinician !== null) {
                    return {
                      icon: () => (
                        <div id={"action-create-test-" + rowData.kitId}>
                          <NoteAdd id={"create-test-" + rowData.kitId} name={"approve-" + rowData.kitId} />
                        </div>
                      ),
                      tooltip: "Create Test Result",
                      onClick: () => showCreateTestResultModal(rowData.kitId)
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (
                    ["REPORT_READY", "REJECTED_BY_CLINICIAN", "COMPLETE"].indexOf(rowData.status) === -1 &&
                    rowData.clinician !== null &&
                    isM19Kit(rowData.kitId)
                  ) {
                    return {
                      icon: () => (
                        <div id={"action-" + rowData.kitId}>
                          <AddBox id={"approve-m19-" + rowData.kitId} name={"approve-" + rowData.kitId} />
                        </div>
                      ),
                      tooltip: "Register Covid-19 Test Tube",
                      onClick: () => showM19FormModal(rowData)
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.status !== "REPORT_READY" && rowData.status !== "REJECTED_BY_CLINICIAN" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician === null) {
                      return;
                    } else {
                      if (rowData.status === "REGISTERED") {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <PostAdd id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId} />
                            </div>
                          ),
                          tooltip: "Add Reject Notes for Patient",
                          onClick: () =>
                            handleShow(
                              rowData.kitId,
                              `Notes for ${rowData.user?.givenName}`,
                              `Hi ${rowData.user?.name.split(" ")[0]},`,
                              rowData.status
                            )
                        };
                      } else {
                        return;
                      }
                    }
                  } else {
                    return;
                  }
                } else {
                  if (rowData.status !== "REPORT_READY" && rowData.status !== "REJECTED_BY_CLINICIAN" && rowData.status !== "COMPLETE") {
                    if (rowData.clinician === null) {
                      return;
                    } else {
                      if (rowData.status === "REGISTERED") {
                        return {
                          icon: () => (
                            <div id={"action-" + rowData.kitId}>
                              <PostAdd className="gray-button" id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId} />
                            </div>
                          ),
                          tooltip: "Assigned to another clinician OR license ineligible",
                          disabled: true
                        };
                      } else {
                        return;
                      }
                    }
                  } else {
                    return;
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.clinician === null) {
                    return;
                  } else {
                    return {
                      icon: () => <Send />,
                      tooltip: "Message Patient",
                      onClick: (e, row) => handleMessageModalset(e, row)
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  (rowData.clinician === null || clinicianId === rowData.clinician.userId)
                ) {
                  if (rowData.clinician === null) {
                    return;
                  } else {
                    return {
                      icon: () => <Healing />,
                      tooltip: "Send Prescription",
                      onClick: (e, row) => handleSendPrescription(e, row)
                    };
                  }
                }
              },
              rowData => {
                if (
                  validStates &&
                  validStates?.includes(getRegion(rowData.user)) &&
                  rowData.clinician !== null &&
                  rowData.clinician.userId !== clinicianId
                ) {
                  return {
                    icon: () => (
                      <div id={"action-create-test-" + rowData.kitId}>
                        <CachedRounded style={{ color: "orange" }} id={"reassign-" + rowData.kitId} name={"reassign-" + rowData.kitId} />
                      </div>
                    ),
                    tooltip: "Reassign To Me",
                    onClick: () => {
                      setActiveKitId(rowData.kitId);
                      setReassignModal(true);
                    }
                  };
                }
              }
            ]}
            data={allStatesShow ? labRequests : myStatesLabRequests}
            options={{
              filtering: false,
              exportButton: true,
              headerStyle: { position: "sticky", top: 0 },
              maxBodyHeight: "630px",
              search: true,
              pageSize: 50,
              pageSizeOptions: [50, 100, 200],
              emptyRowsWhenPaging: false,
              actionsColumnIndex: 1,
              draggable: false,
              showTitle: false
            }}
            // onRowClick={(event, rowData) => navigateToDetailPage(rowData?.kitId)}
          />

          <Modal show={show} onHide={() => handleClose()} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header id="modalHeader">
              <Modal.Title>Reject Notes</Modal.Title>
            </Modal.Header>
            <Modal.Body id="modalBody">
              <Form onSubmit={processNotes}>
                <Form.Group>
                  <Form.Label>Internal Notes</Form.Label>
                  <Form.Control name={"internalNotesText"} as="textarea" id="borderless" rows="5" aria-label="With textarea" disabled={isReadOnly}>
                    {internalNoteText}
                  </Form.Control>
                </Form.Group>
                <hr></hr>
                <Form.Group>
                  <Form.Label>Reject Notes for Patient</Form.Label>
                  <Form.Control name={"externalNotesText"} id="borderless" as="textarea" rows="5" aria-label="With textarea" disabled={isReadOnly}>
                    {externalNoteText}
                  </Form.Control>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={handleClose}>
                Cancel
              </Button>
              {isReadOnly ? (
                ""
              ) : (
                <Button id="msg_reply" class="replyButton sendButton text-right" onClick={processNotes} type={"submit"}>
                  Save Changes
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          {/* <PatientProfileModal onHideModal={() => handleAddressessClose()} user={selectedPatient}
                        show={showAddressDetails} /> */}
        </Row>
        <Backdrop className={classes.backdrop} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert onClose={handleSnackClose} severity={snackSeverity}>
            {snackText}
          </Alert>
        </Snackbar>
        <SendMessageModal show={messageModalShow} onHide={() => setMessageModalShow(false)} sendMessage={sendMessage} />

        {/* <Modal show={show} onHide={() => handleClose()} backdrop={'static'}>
                    <Modal.Header closeButton>
                        <Modal.Title>Reject Notes</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={processNotes}>
                        <span>Internal Notes</span>
                        <InputGroup>
                            <FormControl name={"internalNotesText"} as="textarea" rows="10"
                                cols="120"
                                aria-label="With textarea" disabled={isReadOnly}>
                                {internalNoteText}
                            </FormControl>
                        </InputGroup>
                        <span>Reject Notes for Patient</span>
                        <InputGroup>
                            <FormControl name={"externalNotesText"} as="textarea" rows="10"
                                cols="120"
                                aria-label="With textarea" disabled={isReadOnly}>
                                {externalNoteText}
                            </FormControl>
                        </InputGroup>
                    </Form>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        {
                            isReadOnly ? "" :
                                <Button variant="primary" onClick={processNotes} type={'submit'}>
                                    Save Changes
                                </Button>
                        }
                    </Modal.Footer>
                </Modal> */}

        {/* //& Reassign to Me Modal */}
        {reassignModal && <ReassignModal handleClose={handleReassignKitClose} kit={activeKitId} recordType="LAB_REQUEST" onRefresh={onReassign} />}
        {showErxModal && <ERXModal show={showErxModal} onHide={hideErxModal} eRxid={eRxid} />}

        <PatientProfileModal onHideModal={() => handleAddressessClose()} user={selectedPatient} show={showAddressDetails} />
        <Backdrop className={classes.backdrop} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert onClose={handleSnackClose} severity={snackSeverity}>
            {snackText}
          </Alert>
        </Snackbar>
        <SendMessageModal show={messageModalShow} onHide={() => setMessageModalShow(false)} sendMessage={sendMessage} />
        <M19Input
          show={showM19Modal}
          disabled={isSelectedKitReportReady}
          kitId={selectedKitId}
          tubeId={selectedTubeId}
          handleClose={handleM19InputClose}
        />
        <CreateTestResultModal show={showCreateTestFormModal} kitId={selectedKitId} handleClose={handleCreateTestResultClose} />
      </Container>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Row>
      </Container>
    );
  }
};

function SendMessageModal(props) {
  const [message, setMessage] = useState("");
  const [addedMessage, setAddedMessage] = useState(false);

  const submitCalendlyForm = () => {
    setAddedMessage(true);
    if (message !== "") {
      props.sendMessage(message);
      props.onHide();
    }
  };

  return (
    <Modal {...props} size="lg" backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered>
      <Form>
        <Modal.Header id="modalHeader">
          <Modal.Title>Message Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body id="modalBody">
          {message === "" && addedMessage && <p className="text-red">Make sure you add text</p>}
          <Form.Group controlId="formLink">
            <Form.Control
              id="borderless"
              placeholder="Enter your message here"
              as="textarea"
              rows={5}
              value={message}
              onChange={e => setMessage(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => props.onHide()}>
            Cancel
          </Button>
          <Button id="msg_reply" class="replyButton sendButton text-right" onClick={() => submitCalendlyForm()}>
            Send <i className="fa fa-paper-plane" aria-hidden="true"></i>
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

const TooltipContent = ({ onClose, user }) => {
  return (
    <div
      style={{
        width: "30vw",
        height: "auto",
        padding: "25px",
        background: "white",
        borderRadius: "0px",
        color: "black",
        border: "1px solid lightgray",
        display: "block",
        boxShadow: "0 4px 4px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1)"
      }}
    >
      <Row>
        <Col md={3}>
          <div>
            <Image roundedCircle className="profile-pic" alt={"TBD user "} src={userImage} />
          </div>
        </Col>
        <Col md={8}>
          <div className="userName">{user?.name}</div>
          <div>
            <BsGeoAltFill /> {user?.address?.locality}, {user?.address?.region}
          </div>
        </Col>
        <Col md={1}>
          <BsX className="pointer" onClick={onClose} />
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="modelLabel">Sex at birth:</span> {user?.gender}
        </Col>
        <Col>
          <span className="modelLabel">DOB:</span> {format_yyyy_mm_dd_to_DATETIME_MED(user?.dob)}
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="modelLabel">Address:</span> {user?.address?.street_address}
          {user?.address?.locality}, {user?.address?.region} {user?.address?.postal_code}
        </Col>
        <Col>
          <span className="modelLabel">Phone:</span> {user?.phoneNumber}
        </Col>
      </Row>
      <hr></hr>
      <Row>
        <Col>
          <span className="modelLabel">Allergies:</span> {user?.allergies}
        </Col>
        <Col>
          <span className="modelLabel">Symptoms:</span> {user?.symptoms}
        </Col>
      </Row>
      <Row>
        <Col>
          <span className="modelLabel">Medication:</span> {user?.medication}
        </Col>
        <Col>
          <span className="modelLabel">Sex at birth:</span> {user?.genderAtBirth}
        </Col>
      </Row>
    </div>
  );
};

function ShowProfile({ event }) {
  const [showTooltip, setShowTooltip] = useState(false);

  const closeTooltip = () => {
    setShowTooltip(false);
  };

  const openTooltip = () => {
    setShowTooltip(true);
  };
  const ref = useRef(null);

  const getTarget = () => {
    return ReactDOM.findDOMNode(ref.current);
  };

  return (
    <div ref={ref}>
      <div style={{ color: "#866BD9", cursor: "pointer", textDecoration: "underline" }} onMouseOver={openTooltip} onMouseOut={closeTooltip}
        onClick={() => {
          window.open(`/PatientProfile?patientId=${event?.user?.userId}&idType=sub`, "_blank");
        }}
      >
        {event?.user?.name}
      </div>
      <Overlay rootClose target={getTarget} show={showTooltip} placement="top" onHide={closeTooltip}>
        <Tooltip id="test">
          <TooltipContent user={event?.user} onClose={closeTooltip} />
        </Tooltip>
      </Overlay>
    </div>
  );
}

export default LabRequest;
